(function () {
  if (typeof window !== 'undefined' && window.CurvyRecs) return;

  var UK_VENDORS = ['Panache', 'Wacoal', 'Curvy Kate - Scantilly', 'Elila', 'Cake Lingerie', 'Hotmilk', 'Concept Brands'];
  var NON_UK_VENDORS = [
    'Triumph International',
    'Hanes - Berlei Bonds Jockey Hosier',
    'Nala',
    'P Labs',
    'Simon de Winter',
    'Glamorise',
    'Bendon Fayreform',
    'Leading Lady',
    'Amoena',
    'Exquisite Form',
    'Lady Emprezz'
  ];
  var CUPS = ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ', 'K', 'KK', 'L', 'LL'];
  var UK_SEQ = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ', 'K', 'KK', 'L', 'LL'];
  var NON_UK_SEQ = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'G', 'H', 'J', 'K', 'L'];
  var LETTERS = ['XS', 'S', 'M', 'L', 'XL', '1XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  var LETTER_ALIASES = {
    'X-SMALL': 'XS',
    XSMALL: 'XS',
    SMALL: 'S',
    MEDIUM: 'M',
    LARGE: 'L',
    'X-LARGE': 'XL',
    XLARGE: 'XL',
    'EXTRA LARGE': 'XL',
    XXL: '2XL',
    XXXL: '3XL',
    XXXXL: '4XL'
  };
  var LETTER_LABELS = { '2XL': ['XXL'], '3XL': ['XXXL'] };
  var LETTER_RE = '(XS|S|M|L|XL|XXL|XXXL|[1-6]XL)';

  function clean(raw) {
    return String(raw == null ? '' : raw)
      .replace(/ /g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase()
      .replace(/^[A-Z][A-Z ]{2,} ?-\s*(?=\d)/, '');
  }

  function letter(value) {
    if (LETTER_ALIASES[value]) return LETTER_ALIASES[value];
    return LETTERS.indexOf(value) >= 0 ? value : null;
  }

  function numeric(value) {
    if (!/^[1-9]\d?$/.test(value)) return null;
    var n = parseInt(value, 10);
    return n >= 4 && n <= 30 ? String(n) : null;
  }

  function canonCup(cup) {
    return cup === 'DDD' ? 'E' : cup;
  }

  function cupTokens(text) {
    if (/[\/-]/.test(text)) {
      var parts = text.split(/[\/-]/).map(function (t) {
        return t.replace(/^\d+/, '');
      }).filter(Boolean);
      for (var i = 0; i < parts.length; i++) {
        if (CUPS.indexOf(parts[i]) < 0) return null;
      }
      return parts.length ? parts : null;
    }
    if (CUPS.indexOf(text) >= 0) return [text];
    var best = null;
    (function walk(pos, prev, acc) {
      if (pos === text.length) {
        if (!best || acc.length > best.length) best = acc.slice();
        return;
      }
      for (var len = 3; len >= 1; len--) {
        var token = text.substr(pos, len);
        var idx = CUPS.indexOf(token);
        if (token.length === len && idx > prev) {
          acc.push(token);
          walk(pos + len, idx, acc);
          acc.pop();
        }
      }
    })(0, -1, []);
    return best;
  }

  function expandCups(tokens) {
    if (tokens.length === 1) return [canonCup(tokens[0])];
    var from = CUPS.indexOf(tokens[0]);
    var to = CUPS.indexOf(tokens[tokens.length - 1]);
    var out = [];
    for (var i = from; i <= to; i++) {
      var cup = canonCup(CUPS[i]);
      if (out.indexOf(cup) < 0) out.push(cup);
    }
    return out;
  }

  function parseSize(raw) {
    var s = clean(raw);
    var none = { items: [], exact: false };
    if (!s || /^(ONE SIZE|1 SIZE|DEFAULT TITLE)/.test(s)) return none;
    var m;

    m = s.match(new RegExp('^' + LETTER_RE + ' ?\\(AU ?(\\d{1,2})\\)$'));
    if (m && letter(m[1]) && numeric(m[2])) {
      return { items: [{ f: 'letter', v: letter(m[1]) }, { f: 'num', v: numeric(m[2]) }], exact: true };
    }

    m = s.match(new RegExp('^(\\d{1,2}) ?\\/ ?' + LETTER_RE + '$'));
    if (m && letter(m[2]) && numeric(m[1])) {
      return { items: [{ f: 'num', v: numeric(m[1]) }, { f: 'letter', v: letter(m[2]) }], exact: true };
    }

    m = s.match(new RegExp('^' + LETTER_RE + ' ?[-\\/] ?' + LETTER_RE + '$'));
    if (m && letter(m[1]) && letter(m[2])) {
      return { items: [{ f: 'letter', v: letter(m[1]) }, { f: 'letter', v: letter(m[2]) }], exact: false };
    }

    m = s.match(new RegExp('^' + LETTER_RE + '[- ]([A-L][A-L\\/-]*)$'));
    if (m && letter(m[1]) && cupTokens(m[2])) {
      return { items: [{ f: 'letter', v: letter(m[1]) }], exact: false };
    }

    var single = letter(s);
    if (single) return { items: [{ f: 'letter', v: single }], exact: true };

    var num = numeric(s);
    if (num) return { items: [{ f: 'num', v: num }], exact: true };

    m = s.match(/^(\d{1,2}) ?[-\/] ?(\d{1,2})$/);
    if (m && numeric(m[1]) && numeric(m[2]) && +m[1] < +m[2]) {
      var nums = [];
      for (var n = +m[1]; n <= +m[2]; n += 2) nums.push({ f: 'num', v: String(n) });
      return { items: nums, exact: false };
    }

    m = s.replace(/ /g, '').match(/^(\d{1,2})-?([A-L][A-L0-9\/-]*)$/);
    if (m && +m[1] >= 4) {
      var tokens = cupTokens(m[2]);
      if (tokens) {
        var cups = expandCups(tokens);
        return {
          items: cups.map(function (cup) {
            return { f: 'bra', v: String(+m[1]) + cup };
          }),
          exact: tokens.length === 1
        };
      }
    }

    return none;
  }

  function brandSeq(product) {
    if (UK_VENDORS.indexOf(product.v) >= 0) return UK_SEQ;
    if (NON_UK_VENDORS.indexOf(product.v) >= 0) return NON_UK_SEQ;
    var cups = {};
    (product.a || []).forEach(function (raw) {
      clean(raw).replace(/ /g, '').replace(/^\d{1,2}-?/, '').split(/[\/-]/).forEach(function (part) {
        cups[part] = true;
      });
    });
    if (cups.FF || cups.GG || cups.HH || cups.JJ || cups.KK) return UK_SEQ;
    if (cups.G) return NON_UK_SEQ;
    return null;
  }

  function sistersOf(size, seq) {
    var m = size.match(/^(\d{1,2})([A-Z]+)$/);
    if (!m) return [];
    var band = +m[1];
    var i = seq.indexOf(m[2]);
    if (i < 0) return [];
    var out = [];
    if (i + 1 < seq.length && band - 2 >= 4) out.push(band - 2 + seq[i + 1]);
    if (i - 1 >= 0) out.push(band + 2 + seq[i - 1]);
    return out;
  }

  function itemsOf(list) {
    var out = [];
    (list || []).forEach(function (raw) {
      out = out.concat(parseSize(raw).items);
    });
    return out;
  }

  function classify(product, sizes) {
    var families = {};
    itemsOf(product.a).forEach(function (it) {
      families[it.f] = true;
    });
    var relevant = Object.keys(families).filter(function (f) {
      return sizes[f] && sizes[f].length;
    });
    if (!relevant.length) return 'any';
    var available = itemsOf(product.s);
    var exact = available.some(function (it) {
      return relevant.indexOf(it.f) >= 0 && sizes[it.f].indexOf(it.v) >= 0;
    });
    if (exact) return 'exact';
    if (relevant.indexOf('bra') >= 0) {
      var seq = brandSeq(product);
      if (seq) {
        var sisters = [];
        sizes.bra.forEach(function (size) {
          sisters = sisters.concat(sistersOf(size, seq));
        });
        var sister = available.some(function (it) {
          return it.f === 'bra' && sisters.indexOf(it.v) >= 0;
        });
        if (sister) return 'sister';
      }
    }
    return null;
  }

  var api = {
    parseSize: parseSize,
    classify: classify,
    sistersOf: sistersOf,
    brandSeq: brandSeq,
    UK_SEQ: UK_SEQ,
    NON_UK_SEQ: NON_UK_SEQ
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }
  window.CurvyRecs = api;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SIZE_KEY = 'curvy-recs-sizes';
  var ALL_SIZES_KEY = 'curvy-recs-all-sizes';
  var LAST_COLLECTION_KEY = 'curvy-recs-last-collection';
  var HISTORY_KEY = 'yv-recently-viewed';
  var HANDLES_KEY = 'curvy-recs-handles';
  var TTL = 90 * 24 * 60 * 60 * 1000;
  var PER_FAMILY = 3;
  var MIN_PRODUCTS = 4;
  var FAMILIES = ['bra', 'letter', 'num'];

  function readJSON(storage, key, fallback) {
    try {
      var value = storage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function writeJSON(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function loadMemory() {
    var memory = readJSON(localStorage, SIZE_KEY, null);
    if (!memory || !memory.t || Date.now() - memory.t > TTL) memory = { t: 0, bra: [], letter: [], num: [] };
    FAMILIES.forEach(function (f) {
      if (!Array.isArray(memory[f])) memory[f] = [];
    });
    return memory;
  }

  function remember(items, replace) {
    if (!items.length) return;
    var memory = loadMemory();
    var grouped = {};
    items.forEach(function (it) {
      (grouped[it.f] = grouped[it.f] || []).push(it.v);
    });
    Object.keys(grouped).forEach(function (f) {
      var list = replace ? [] : memory[f].slice();
      grouped[f].slice().reverse().forEach(function (v) {
        list = list.filter(function (x) {
          return x !== v;
        });
        list.unshift(v);
      });
      memory[f] = list.slice(0, PER_FAMILY);
    });
    memory.t = Date.now();
    writeJSON(localStorage, SIZE_KEY, memory);
  }

  function currentSizes(orderSizes) {
    var empty = { bra: [], letter: [], num: [] };
    if (readJSON(sessionStorage, ALL_SIZES_KEY, false)) return empty;
    var memory = loadMemory();
    var fallback = {};
    (orderSizes || []).forEach(function (raw) {
      var parsed = parseSize(raw);
      if (!parsed.exact) return;
      parsed.items.forEach(function (it) {
        (fallback[it.f] = fallback[it.f] || []).push(it.v);
      });
    });
    var sizes = {};
    FAMILIES.forEach(function (f) {
      sizes[f] = memory[f].length ? memory[f] : (fallback[f] || []).slice(0, PER_FAMILY);
    });
    return sizes;
  }

  function hasSizes(sizes) {
    return FAMILIES.some(function (f) {
      return sizes[f].length > 0;
    });
  }

  function captureCollectionFilter() {
    var params = new URLSearchParams(window.location.search);
    var values = params.getAll('filter.v.option.size');
    if (!values.length) return;
    var items = [];
    values.forEach(function (raw) {
      var parsed = parseSize(raw);
      if (parsed.exact) items = items.concat(parsed.items);
    });
    remember(items, true);
  }

  function captureProductPage(widget) {
    var sizeIndex = parseInt(widget.dataset.sizeIndex, 10);
    if (!sizeIndex || window.curvyRecsPdpBound) return;
    window.curvyRecsPdpBound = true;
    var picked = [];

    function selectedSize() {
      var select = document.querySelector('select[name="option-' + sizeIndex + '"]');
      return select ? select.value : null;
    }

    function store(raw) {
      var parsed = parseSize(raw);
      if (parsed.exact) remember(parsed.items, false);
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.tagName !== 'SELECT') return;
      var name = (target.name || '').replace('sticky-', '');
      if (name !== 'option-' + sizeIndex) return;
      var value = target.value;
      if (!value || picked.indexOf(value) >= 0 || picked.length >= 2) return;
      picked.push(value);
      store(value);
    });

    document.addEventListener(
      'click',
      function (event) {
        var button = event.target && event.target.closest && event.target.closest('.add_to_cart, [name="add"]');
        if (!button) return;
        var value = selectedSize();
        if (value) store(value);
      },
      true
    );
  }

  var dataCache = {};

  function fetchData(url) {
    if (!dataCache[url]) {
      dataCache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var node = doc.querySelector('[data-curvy-recs-data]');
          return node ? JSON.parse(node.textContent).filter(Boolean) : [];
        })
        .catch(function () {
          return [];
        });
    }
    return dataCache[url];
  }

  function recsData(productId) {
    return fetchData(ROOT + 'recommendations/products?product_id=' + productId + '&limit=10&intent=related&section_id=curvy-recs-data');
  }

  function searchQuery(ids) {
    return encodeURIComponent(
      ids
        .map(function (id) {
          return 'id:' + id;
        })
        .join(' OR ')
    );
  }

  function productUrl(handle, section) {
    return ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=' + section;
  }

  function productsData(ids) {
    if (!ids.length) return Promise.resolve([]);
    var handles = readJSON(localStorage, HANDLES_KEY, {});
    return fetchData(ROOT + 'search?type=product&q=' + searchQuery(ids) + '&section_id=curvy-recs-data').then(function (list) {
      var byId = {};
      list.forEach(function (p) {
        byId[p.i] = p;
      });
      var missing = ids.filter(function (id) {
        return !byId[id] && handles[id];
      });
      return Promise.all(
        missing.map(function (id) {
          return fetchData(productUrl(handles[id], 'curvy-recs-data'));
        })
      ).then(function (extra) {
        extra.forEach(function (one) {
          one.forEach(function (p) {
            byId[p.i] = p;
          });
        });
        return ids
          .map(function (id) {
            return byId[id];
          })
          .filter(Boolean);
      });
    });
  }

  function rememberHandle(id, handle) {
    var handles = readJSON(localStorage, HANDLES_KEY, {});
    delete handles[id];
    handles[id] = handle;
    var keys = Object.keys(handles);
    if (keys.length > 30) {
      keys.slice(0, keys.length - 30).forEach(function (k) {
        delete handles[k];
      });
    }
    writeJSON(localStorage, HANDLES_KEY, handles);
  }

  function fetchCards(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var templates = {};
        doc.querySelectorAll('template[data-curvy-recs-card]').forEach(function (t) {
          // DOMParser parses <noscript> as markup, so its full-size fallback <img> would load once imported.
          t.content.querySelectorAll('noscript').forEach(function (n) {
            n.remove();
          });
          templates[t.getAttribute('data-curvy-recs-card')] = t;
        });
        return templates;
      })
      .catch(function () {
        return {};
      });
  }

  function sizeFilterValues(sizes) {
    var values = [];
    function add(v) {
      if (values.indexOf(v) < 0) values.push(v);
    }
    sizes.bra.forEach(function (size) {
      add(size);
      sistersOf(size, UK_SEQ).concat(sistersOf(size, NON_UK_SEQ)).forEach(add);
    });
    sizes.letter.forEach(function (size) {
      add(size);
      (LETTER_LABELS[size] || []).forEach(add);
    });
    sizes.num.forEach(add);
    return values;
  }

  function collectionData(handle, sort, sizes, productType) {
    if (!handle) return Promise.resolve([]);
    var base = ROOT + 'collections/' + encodeURIComponent(handle) + '?sort_by=' + sort + '&section_id=curvy-recs-data';
    if (productType) base += '&filter.p.product_type=' + encodeURIComponent(productType);
    var requests = [fetchData(base)];
    if (hasSizes(sizes)) {
      var filtered = base + sizeFilterValues(sizes).map(function (v) {
        return '&filter.v.option.size=' + encodeURIComponent(v);
      }).join('');
      requests.push(fetchData(filtered));
    }
    return Promise.all(requests).then(function (lists) {
      return mergeLists(lists);
    });
  }

  function mergeLists(lists) {
    var seen = {};
    var out = [];
    lists.forEach(function (list) {
      list.forEach(function (p) {
        if (!seen[p.i]) {
          seen[p.i] = true;
          out.push(p);
        }
      });
    });
    return out;
  }

  function interleave(lists) {
    var out = [];
    var seen = {};
    var longest = Math.max.apply(null, [0].concat(lists.map(function (l) {
      return l.length;
    })));
    for (var i = 0; i < longest; i++) {
      lists.forEach(function (list) {
        var p = list[i];
        if (p && !seen[p.i]) {
          seen[p.i] = true;
          out.push(p);
        }
      });
    }
    return out;
  }

  function blend(ids, exclude) {
    return Promise.all(ids.slice(0, 4).map(recsData)).then(function (lists) {
      return interleave(lists).filter(function (p) {
        return exclude.indexOf(p.i) < 0;
      });
    });
  }

  function history(currentId) {
    var list = readJSON(localStorage, HISTORY_KEY, []);
    if (!Array.isArray(list)) return [];
    return list
      .map(function (id) {
        return parseInt(id, 10);
      })
      .filter(function (id) {
        return id && id !== currentId;
      });
  }

  function candidates(widget, sizes) {
    var d = widget.dataset;
    var currentId = parseInt(d.productId, 10) || 0;
    var viewed = history(currentId);
    var cartIds = (d.cartIds || '').split(',').map(function (id) {
      return parseInt(id, 10);
    }).filter(Boolean);
    var source = d.source;
    var primary;

    if (source === 'related') {
      primary = currentId ? recsData(currentId) : Promise.resolve([]);
    } else if (source === 'history') {
      primary = viewed.length ? blend(viewed, viewed.concat([currentId])) : null;
    } else if (source === 'recent_related') {
      primary = viewed.length ? blend(viewed.slice(0, 1), viewed.concat([currentId])) : null;
    } else if (source === 'recent') {
      primary = viewed.length ? productsData(viewed.slice(0, 14)) : null;
    } else if (source === 'collection_current') {
      primary = collectionData(d.currentCollection, 'best-selling', sizes);
    } else if (source === 'collection') {
      primary = collectionData(d.collection, d.sort || 'best-selling', sizes);
    } else if (source === 'last_collection') {
      var last = readJSON(localStorage, LAST_COLLECTION_KEY, null);
      primary = collectionData(last || d.collection, 'best-selling', sizes);
    } else if (source === 'cart') {
      primary = cartIds.length ? blend(cartIds, cartIds) : null;
    }

    if (!primary) {
      if (d.fallback === 'all_best') primary = collectionData('all', 'best-selling', sizes);
      else if (d.fallback === 'type_best' && d.productType) primary = collectionData('all', 'best-selling', sizes, d.productType);
      else primary = Promise.resolve([]);
    }

    var topUp = d.topUp === 'true' ? collectionData('all', 'best-selling', sizes) : Promise.resolve([]);
    return Promise.all([primary, topUp]);
  }

  function choose(widget, lists, sizes, shown) {
    var d = widget.dataset;
    var count = parseInt(d.count, 10) || 12;
    var restrictId = d.restrict === 'true' ? parseInt(d.currentCollectionId, 10) : 0;

    function pick(list) {
      var exact = [];
      var sister = [];
      list.forEach(function (p) {
        if (shown[p.i]) return;
        if (restrictId && (p.c || []).indexOf(restrictId) < 0) return;
        var match = classify(p, sizes);
        if (match === 'exact' || match === 'any') exact.push(p);
        else if (match === 'sister') sister.push(p);
      });
      return exact.concat(sister);
    }

    var chosen = pick(lists[0]);
    if (chosen.length < MIN_PRODUCTS && d.topUp === 'true') chosen = mergeLists([chosen, pick(lists[1])]);
    chosen = chosen.slice(0, count);
    if (chosen.length < MIN_PRODUCTS) return [];
    chosen.forEach(function (p) {
      shown[p.i] = true;
    });
    return chosen;
  }

  function relevantSizes(chosen, sizes) {
    var families = {};
    chosen.forEach(function (p) {
      itemsOf(p.a).forEach(function (it) {
        families[it.f] = true;
      });
    });
    var out = [];
    FAMILIES.forEach(function (f) {
      if (families[f]) out = out.concat(sizes[f]);
    });
    return out;
  }

  function hide(widget) {
    var section = widget.closest('.shopify-section');
    if (section) section.style.display = 'none';
  }

  function addTracking(card, handle, trackedUrl) {
    var tracked;
    try {
      tracked = new URL(trackedUrl, window.location.origin);
    } catch (e) {
      return;
    }
    card.querySelectorAll('a[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin || !/\/products\/[^\/]+$/.test(url.pathname)) return;
      if (url.pathname.split('/').pop() !== handle) return;
      tracked.searchParams.forEach(function (value, key) {
        if (key.indexOf('pr_') === 0) url.searchParams.set(key, value);
      });
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  function renderCards(widget, chosen, sizes) {
    var ids = chosen.map(function (p) {
      return p.i;
    });
    return fetchCards(ROOT + 'search?type=product&q=' + searchQuery(ids) + '&section_id=curvy-recs-cards')
      .then(function (templates) {
        var missing = chosen.filter(function (p) {
          return !templates[p.i] && p.h;
        });
        return Promise.all(
          missing.map(function (p) {
            return fetchCards(productUrl(p.h, 'curvy-recs-cards'));
          })
        ).then(function (extra) {
          extra.forEach(function (more) {
            Object.keys(more).forEach(function (id) {
              templates[id] = more[id];
            });
          });
          return templates;
        });
      })
      .then(function (templates) {
        var slider = widget.querySelector('[data-curvy-recs-slider]');
        var added = 0;
        chosen.forEach(function (p) {
          var t = templates[p.i];
          if (!t) return;
          var card = document.importNode(t.content, true);
          if (p.u && p.h) addTracking(card, p.h, p.u);
          slider.appendChild(card);
          added++;
        });
        if (added < MIN_PRODUCTS) {
          hide(widget);
          return;
        }

        var shownSizes = relevantSizes(chosen, sizes);
        var note = widget.querySelector('[data-curvy-recs-note]');
        if (note && shownSizes.length) {
          note.querySelector('[data-curvy-recs-note-text]').textContent =
            'Showing ' + (shownSizes.length > 1 ? 'sizes ' : 'size ') + shownSizes.join(', ');
          note.hidden = false;
        } else if (note) {
          note.hidden = true;
        }

        var section = widget.closest('.shopify-section');
        if (section) section.style.display = 'block';

        if (added > 5 && slider.getAttribute('data-curvy-flickity')) {
          slider.setAttribute('data-flickity-slider', slider.getAttribute('data-curvy-flickity'));
          if (window.innerWidth > 767 && window.jQuery && typeof window.flickitySlider === 'function') {
            window.flickitySlider(window.jQuery(slider));
          }
        }
        if (typeof window.gridPickUpAvailability === 'function') window.gridPickUpAvailability(widget);
        if (typeof window.showMultipleOptions === 'function') window.showMultipleOptions();
      })
      .catch(function () {
        hide(widget);
      });
  }

  function resetWidget(widget) {
    var slider = widget.querySelector('[data-curvy-recs-slider]');
    if (window.jQuery && slider.classList.contains('flickity-enabled')) {
      window.jQuery(slider).flickity('destroy');
    }
    slider.removeAttribute('data-flickity-slider');
    slider.innerHTML = '';
  }

  function run() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('[data-curvy-recs]'));
    if (!widgets.length) return;
    var orderSizes = [];
    try {
      orderSizes = JSON.parse(widgets[0].dataset.orderSizes || '[]');
    } catch (e) {}
    var sizes = currentSizes(orderSizes);
    var shown = {};
    widgets.forEach(function (widget) {
      var d = widget.dataset;
      if (d.productId) shown[parseInt(d.productId, 10)] = true;
      (d.cartIds || '').split(',').forEach(function (id) {
        if (id) shown[parseInt(id, 10)] = true;
      });
    });

    var pending = widgets.map(function (widget) {
      return candidates(widget, sizes);
    });

    var chain = Promise.resolve();
    widgets.forEach(function (widget, index) {
      chain = chain.then(function () {
        return pending[index].then(function (lists) {
          var chosen = choose(widget, lists, sizes, shown);
          if (!chosen.length) {
            hide(widget);
            return;
          }
          renderCards(widget, chosen, sizes);
        });
      });
    });
  }

  function init() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('[data-curvy-recs]'));
    if (!widgets.length) return;

    captureCollectionFilter();
    widgets.forEach(function (widget) {
      if (widget.dataset.currentCollection) writeJSON(localStorage, LAST_COLLECTION_KEY, widget.dataset.currentCollection);
      if (widget.dataset.productId && widget.dataset.productHandle) rememberHandle(widget.dataset.productId, widget.dataset.productHandle);
      if (widget.dataset.sizeIndex) captureProductPage(widget);
    });

    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest && event.target.closest('[data-curvy-recs-show-all]');
      if (!button) return;
      writeJSON(sessionStorage, ALL_SIZES_KEY, true);
      widgets.forEach(resetWidget);
      run();
    });

    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
